import { type PropsWithChildren, createContext, useCallback, useContext, useState } from 'react';

import { type PageFilterContextProps, type PageFiltersType } from './types';

type Props = {
  className?: string;
};

const PageFilterContext = createContext<PageFilterContextProps | undefined>(undefined);

export const usePageFilterContext = () => {
  const context = useContext(PageFilterContext);
  if (!context) {
    throw new Error('useFilterContext must be used within a DashboardFilterProvider');
  }
  return context;
};

const PageFilterProvider = ({ children }: PropsWithChildren<Props>) => {
  const [filters, setFilters] = useState<PageFiltersType>({});

  const handlePageFiltersChange = useCallback(
    (newFilters: Partial<PageFiltersType>) => {
      setFilters((previousFilters) => ({ ...previousFilters, ...newFilters }));
    },
    [setFilters],
  );

  return (
    <PageFilterContext.Provider
      value={{ pageFilters: filters, setPageFilters: handlePageFiltersChange }}
    >
      {children}
    </PageFilterContext.Provider>
  );
};

export default PageFilterProvider;
